(function () {
  'use strict';

  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  const SECTION_NAME = 'cart-drawer';

  // Sections to fully replace on cart update
  // Tiered rewards is EXCLUDED — we never touch its DOM, only data attributes
  const OWNED = [
    '.cart-drawer__section--double-the-fun',
    '.cart-drawer__section--estimated-delivery',
    '.cart-drawer__section--price-breakdown',
    '.cart-drawer__footer',
  ];

  let _inflight = false;
  let _queued   = false;
  let _timer    = null;

  async function fetchSection() {
    try {
      const res = await fetch(`/cart?sections=${SECTION_NAME}&t=${Date.now()}`,
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!res.ok) return null;
      const json = await res.json();
      return json[SECTION_NAME] || null;
    } catch (e) { return null; }
  }

  async function fetchFinalLineTotal() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      let total  = 0;
      if (cart.items) cart.items.forEach(item => { total += item.final_line_price; });
      return total;
    } catch (e) { return null; }
  }

  function updateTieredRewards(total) {
    // Only update data-cart-total attribute and call JS update
    // NEVER touch innerHTML — the fill element must stay alive for CSS transitions
    const root = drawer.querySelector('.js-cart-tiered-rewards');
    if (!root) return;
    if (total !== null) root.setAttribute('data-cart-total', total);
    if (typeof window.CartTieredRewardsUpdate === 'function') {
      window.CartTieredRewardsUpdate();
    }
  }

  function patch(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Replace all non-tiered sections
    OWNED.forEach(sel => {
      const fresh = doc.querySelector(sel);
      const live  = drawer.querySelector(sel);
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    });

    // Count + title
    const freshCount = doc.querySelector('.cart-items-container__count');
    const liveCount  = drawer.querySelector('.cart-items-container__count');
    if (freshCount && liveCount) liveCount.textContent = freshCount.textContent;
    const freshTitle = doc.querySelector('.drawer__title');
    const liveTitle  = drawer.querySelector('.drawer__title');
    if (freshTitle && liveTitle) liveTitle.innerHTML = freshTitle.innerHTML;

    // Tiered rewards: fetch real total and update via JS only (no DOM replacement)
    fetchFinalLineTotal().then(total => updateTieredRewards(total));
  }

  async function run() {
    if (_inflight) { _queued = true; return; }
    _inflight = true;
    try {
      const html = await fetchSection();
      if (html) patch(html);
    } finally {
      _inflight = false;
      if (_queued) { _queued = false; run(); }
    }
  }

  function schedule(delay) {
    clearTimeout(_timer);
    _timer = setTimeout(run, delay || 400);
  }

  ['cart:updated','cart:change','cart:refresh','cart:item:added',
   'cart:item:removed','kcart:updated','kcart:cart']
    .forEach(ev => document.addEventListener(ev, () => schedule(400)));

  const _origFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const res = await _origFetch.apply(this, args);
    if (/\/cart\/(add|update|change|clear)/.test(url)) schedule(600);
    return res;
  };

  const _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    if (/\/cart\/(add|update|change|clear)/.test(url)) {
      this.addEventListener('load', () => schedule(600));
    }
    return _origOpen.call(this, method, url, ...rest);
  };

  function watchItems() {
    const body = drawer.querySelector('.cart-items__body');
    if (!body) return;
    let obs_timer = null;
    new MutationObserver(() => {
      const isOpen = drawer.classList.contains('is-active') ||
                     drawer.classList.contains('is-open') ||
                     drawer.getAttribute('aria-hidden') === 'false';
      if (!isOpen) return;
      clearTimeout(obs_timer);
      obs_timer = setTimeout(run, 300);
    }).observe(body, { childList: true, subtree: true });
  }

  let _initialised = false;

  function onDrawerOpen() {
    if (!_initialised) { _initialised = true; watchItems(); }
    fetchFinalLineTotal().then(total => updateTieredRewards(total));
  }

  new MutationObserver(mutations => {
    for (const m of mutations) {
      if (m.attributeName === 'class' || m.attributeName === 'aria-hidden') {
        const isOpen = drawer.classList.contains('is-active') ||
                       drawer.classList.contains('is-open') ||
                       drawer.getAttribute('aria-hidden') === 'false';
        if (isOpen) { onDrawerOpen(); break; }
      }
    }
  }).observe(drawer, { attributes: true });

  document.querySelectorAll('[data-js-toggle="CartDrawer"], [data-target="CartDrawer"]')
    .forEach(btn => btn.addEventListener('click', () => setTimeout(onDrawerOpen, 300)));

})();
